module.exports = __webpack_public_path__ + "static/containers-282b2a152ad9f12fbffcf43c3d6cefdb.png";